'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _singleClickHoldsSettingsShape = require('./singleClickHoldsSettingsShape');

var _singleClickHoldsSettingsShape2 = _interopRequireDefault(_singleClickHoldsSettingsShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountShape = _reactImmutableProptypes2.default.contains({
  id: _react.PropTypes.number,
  libId: _react.PropTypes.number,
  digitalNotificationEmail: _react.PropTypes.string,
  expiryDate: _react.PropTypes.string,
  importedILSShelves: _react.PropTypes.bool,
  borrowingHistoryEnabled: _react.PropTypes.bool,
  singleClickHoldsSettings: _singleClickHoldsSettingsShape2.default,
  preferredLocations: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)
});

exports.default = accountShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/accountShape.js
// module id = 363
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16